import { AxiosInstance } from 'axios';
import { axiosFactory } from '../../../../client';
import { CodeValueResponse, KeyValueResponse } from '../../../../model';
import * as ROUTES from './routes';
import {
  CoordinatorDetails,
  FunctionAccessCheckRequest,
  OopAdminResitRegisterDetailRequestData,
  OopAdminResitSearchCandidateResponse,
  OppAdminResitRegisterDetailResponse,
  OpsAdminResitRegistrationDetailData,
} from './models';
import { OopAdminResitRegistrationDetails } from '../models';
import { BulkDownloadOrgAdminResultReleaseResponse } from '../../../result/@opadmin/models';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/resit`;
const userApiBaseURL = `/user/api`;
const candidateApiBaseURL = `/candidate/api`;
const timeout = 5000;

const resitClient = axiosFactory(baseURL, timeout);

export const resitOopAdminClient = axiosFactory('', timeout);

export const resitTestOopAdminClient = (resitClient as unknown) as AxiosInstance;

/** to get oop admin school list option
 */
export const getResitOopAdminOrganizationOptions = () =>
  resitOopAdminClient.get<KeyValueResponse[]>(
    `${userApiBaseURL}/admin/${ROUTES.GET_OPS_ADMIN_RESIT_ORGANIZATION}`
  );

/** to get oop admin action list option
 */
export const getResitOopAdminActionOptions = () =>
  resitOopAdminClient.get<KeyValueResponse[]>(
    `${userApiBaseURL}/admin/${ROUTES.GET_OPS_ADMIN_RESIT_ACTIONS}`
  );

/** to get exam levels data
 * */
export const getResitOopAdminCoordinatorsBySchool = (organizationId: string) =>
  resitOopAdminClient.get<CoordinatorDetails[]>(
    `${userApiBaseURL}/${ROUTES.GET_COORDINATOR_BY_SCHOOL}/${organizationId}/coordinators`
  );

/** to search candidate
 * */
export const postResitOopAdminSearchCandidate = (
  csrfToken: string,
  data: { candidateId: string }
) =>
  resitOopAdminClient.post<OopAdminResitSearchCandidateResponse>(
    csrfToken,
    `${candidateApiBaseURL}/${ROUTES.POST_OPP_ADMIN_SEARCH_CANDIDATE}`,
    data
  );

/** to retrieve coordinator candidate resit register details
 * */
export const postGetOopAdminCandidateResitRegisterDetails = (
  csrfToken: string,
  params: OopAdminResitRegisterDetailRequestData
) =>
  resitOopAdminClient.post<OppAdminResitRegisterDetailResponse>(
    csrfToken,
    `${candidateApiBaseURL}/${ROUTES.POST_OOP_ADMIN_RESIT_REGISTER_DETAIL}?page=${params.page}&size=${params.size}&order=${params.order}`,
    params.payload
  );

/** to download coordinator candidate resit register details
 * */
export const postDownloadOopAdminCandidateResitRegisterDetails = (
  csrfToken: string,
  data: OpsAdminResitRegistrationDetailData
) =>
  resitOopAdminClient.post<BulkDownloadOrgAdminResultReleaseResponse>(
    csrfToken,
    `${candidateApiBaseURL}/${ROUTES.POST_OOP_ADMIN_DOWNLOAD_RESIT_REGISTER_DETAIL}`,
    data
  );

/** to get  coordinator particular candidate resit register details
 * */
export const getIndividualCandidateRegistration = (indexNo: string) =>
  resitOopAdminClient.get<OopAdminResitRegistrationDetails>(
    `${candidateApiBaseURL}/${ROUTES.GET_OOP_ADMIN_RESIT_REGISTER_INDIVIDUAL_DETAIL}/${indexNo}`
  );

/** to get exam levels option data
 * */
export const getExamLevelsOptions = (param: FunctionAccessCheckRequest) =>
  resitOopAdminClient.get<CodeValueResponse[]>(
    `${candidateApiBaseURL}/admin/candidate/dropdown-filter/${ROUTES.GET_EXAM_LEVEL_OPTIONS}`,
    param
  );

/** to get school options
 * */
export const getSchoolOptions = () =>
  resitOopAdminClient.get<CodeValueResponse[]>(
    `${candidateApiBaseURL}/admin/candidate/dropdown-filter/${ROUTES.GET_SCHOOL_OPTIONS}`
  );

/** to get school code options
 * */
export const getPaymentModeOptions = () =>
  resitOopAdminClient.get<KeyValueResponse[]>(
    `${candidateApiBaseURL}/admin/filter-listing/type/${ROUTES.GET_PAYMENT_MODE_OPTIONS}`
  );
